<template>
    <div class="landing">
        <div class="circle sparkle left30 tp10"></div>
        <div class="circle sparkle left10 tp60"></div>
        <div class="circle sparkle left40 tp90"></div>
        <div class="circle sparkle left70 tp70"></div>
        <div class="circle sparkle left70 tp20"></div>
        <div class="circle sparkle left90 tp40"></div>
        <div class="circle sparkle left30 tp40"></div>

        <div class="intro">
            <h1>Hello I'm <span>Akash</span><br/>I'm a <span>web developer</span></h1>
            <router-link class="button" :to="{ name: 'Profile' }">
                View Profile
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Landing',
    methods: {
        ...mapActions(['hideMenu', 'hideFooter']),
    },
    created() {
        this.hideMenu();
        this.hideFooter();
    }
}
</script>

<style scoped>
.landing {
    text-align: center;
    /* background: radial-gradient(ellipse at top, #e66465, transparent),
            radial-gradient(ellipse at bottom, #4d9f0c, transparent); */
    background: radial-gradient(ellipse at center, #1b2735 0%,#090a0f 100%);
    
    height: 100vh;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.intro {
    position: absolute;
    top: 40%;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    z-index: 100;
}
h1 {
    color: rgb(221, 221, 221);
    color: #ccc;
    font-size: 1.8em;
    display: block;
    align-self: center;
    font-family: lato-regular;
}
h1 span {
    color: rgb(69, 145, 231);
    color: white;
}
.button {
    align-self: center;
}
.button:hover {
    background: var(--light-blue);
    border-color: var(--light-blue);
}
.circle {
    width: .1px;
    height: .1px;
    border-radius: 50%;
    position: absolute;
    box-shadow: 0px 0px var(--blur-radius) var(--spread-radius) var(--blue); 
}
.sparkle {
    animation-name: sparkle-anim;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}

@keyframes sparkle-anim {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
}

@media (min-width: 410px) {
    .intro {
        top: 35%;
    }
}
@media (min-width: 768px) {
    .intro {
        top: 30%;
    }
    h1 {
        font-size: 2.5em;
    }
    .button {
        font-size: 1.2em;
    };
}
@media (min-width: 1024px) {
    
}
@media (min-width: 1366px) {
    
}
@media (min-width: 1920px) {
    h1 {
        font-size: 3em;
    }
}
</style>